module.exports = __webpack_public_path__ + "static/img/header.88c56e70.png";